import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

import { Button, Fade } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FileUpload from 'components/FileUpload'

const emptyStatusText = 'Klik hier of sleep een Excel bestand hierheen om deze te importeren'

class ImportFileUpload extends React.Component {
    state = {
        file: {}
    }

    handleAccepted = file => {
        this.setState({
            file
        }, this.props.onFileSelect(file))
    }

    render() {
        return (
            <React.Fragment>
                <FileUpload
                    { ...this.props }
                    onAccept={ this.handleAccepted }
                    emptyStatusText={ emptyStatusText }
                    showStatus
                    showAddButton
                />

                <Fade
                    in={ !isEmpty(this.state.file) }
                    tag="div"
                    className="ao-importdetail__actions"
                >
                    { this.props.actions.map((action, index) => {
                        return (
                            <Button
                                key={ `organisation-import-action-button-${index}` }
                                disabled={ isEmpty(this.state.file) || this.props.isLoading === true }
                                onClick={ action.handle }
                                className="ao-importdetail__action mx-1"
                            >
                                {action.icon && <FontAwesomeIcon icon={ action.icon } />} {action.title}
                            </Button>
                        )
                    })}
                </Fade>
            </React.Fragment>
        )
    }
}

ImportFileUpload.propTypes = {
    onFileSelect: PropTypes.func,
    actions: PropTypes.arrayOf(PropTypes.object),
    isLoading: PropTypes.bool
}

export default ImportFileUpload
